import { useGameContainer } from '../index';
import compact from 'helpers/compact';
import StandingsTable from '@/components/StandingsTable';
import ContentSection, { ContentSectionFlushContent, ContentSectionFooterButton, ContentSectionHeader } from '@/components/ContentSection';

export default function GameStandings() {
  const [{ game }] = useGameContainer();

  const teamIds = game.gameTeams.map(gameTeam => gameTeam.team.id);

  function isHighlighted(teamStanding: { team: { id: string } }) {
    return teamIds.includes(teamStanding.team.id);
  }

  if (game.contest?.bracket?.bracketContestTeams) {
    const teamStandings = game.contest.bracket.bracketContestTeams
      .map(bracketContestTeam => {
        if (!bracketContestTeam.team) return null;
        const { standing, ...team } = bracketContestTeam.team;

        return {
          team,
          standing
        };
      })
      .filter(compact)
      .slice(0, 10);

    return (
      <ContentSection>
        <ContentSectionHeader>{game.contest.bracket.name}</ContentSectionHeader>
        <ContentSectionFlushContent>
          <StandingsTable teamStandings={teamStandings} isHighlighted={isHighlighted} />
        </ContentSectionFlushContent>
        <ContentSectionFooterButton href={game.contest.bracket.webPath}>Playoff Central</ContentSectionFooterButton>
      </ContentSection>
    );
  }

  if (!game.league) return null;

  return (
    <ContentSection>
      <ContentSectionHeader>{game.league.fullName || game.league.name}</ContentSectionHeader>
      <ContentSectionFlushContent>
        <StandingsTable teamStandings={game.league.teamStandings} isHighlighted={isHighlighted} />
      </ContentSectionFlushContent>
      <ContentSectionFooterButton href={game.league.webPath}>See {game.league.label} Profile</ContentSectionFooterButton>
    </ContentSection>
  );
}
